__turbopack_context__.v({
  "collapsibleContent": "q79YjG_collapsibleContent",
  "header": "q79YjG_header" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "headerIcon": "q79YjG_headerIcon",
  "item": "q79YjG_item",
  "slideDown": "q79YjG_slideDown",
  "slideUp": "q79YjG_slideUp",
});
